var RestDao = require("spscript").RestDao;

var _getList = function(listname) {
	return new RestDao(_spPageContextInfo.siteAbsoluteUrl).lists(listname);
}

// var lists = {
// 	get LinksMyAccount (){
// 		return _getList("LinksMyAccount");
// 	}
// };

var listNames = ["LinksMyAccount", "TeaserContent"];


var lists = {};

listNames.forEach(name => {
	Object.defineProperty(lists, name, {
		get: _getList.bind(null, name)
	});
});

module.exports = lists;


// WEBPACK FOOTER //
// ./src/scripts/shared/lists.js